import { useItemsRealtime } from 'screens/Finder/hooks/useRealtime'
import { RefreshPayload } from 'screens/Finder/FinderContextTypes'
import { useLocalDebouncedFn } from 'hooks/useLocalDebouncedFn'
import { getUniqueIdentifier } from 'utils/sessionStorage'
import { HandbookV2 } from 'types'

const useRealtime = ({ currentHandbook, onUpdate }: { currentHandbook?: HandbookV2 | null; onUpdate: () => void }) => {
  const currentSessionUuid = getUniqueIdentifier()

  const refreshAfterExternalChange = useLocalDebouncedFn(
    ({ session_uuid }: RefreshPayload) => {
      if ((session_uuid && session_uuid === currentSessionUuid) || !currentHandbook) return
      onUpdate()
    },
    300, // Debounce interval
    {},
    [onUpdate, currentSessionUuid],
  )

  useItemsRealtime({
    folderId: currentHandbook?.folder?.key,
    onItemsMessage: refreshAfterExternalChange,
  })
}

export { useRealtime }
